module.exports = __webpack_public_path__ + "img/imgaudio.f38cca97.png";